import { hasInvalidCharsInAssetName, resetAssetNameIfDefault } from 'features/asset';
import { wishListErrorMessages } from 'features/wishList/desktop';
import { momentaryMessageDuration } from 'ui/config';

/**
 * This is a wrapper function to the lpContentEditable jQuery plugin.
 * This can be called anywhere you want an element to be editable.
 * The default options are for Wish List but you can override them by passing your own options object.
 */
window.lp.utils.initContentEditable = function ($editableElement, options, buttons) {

	const defaults = {
		maxLength: $editableElement.data('maxlength'),
		buttons: {
			submit: {
				label: 'Update',
				tagName: 'button',
				cssClass: 'calloutBtn alt1 large'
			},
			cancel: {
				tagName: 'button',
				cssClass: 'calloutBtn alt2 large'
			},
			divider: buttons && buttons.divider ? buttons.divider : '|'
		},
		ajaxMethod: 'PUT',
		paramName: false,
		successMessage: '',
		editLinkText: buttons && buttons.editLinkText ? buttons.editLinkText : 'Rename',
		editLinkAriaLabel: buttons && buttons.editLinkAriaLabel ? buttons.editLinkAriaLabel : '',
		messageFadeOutTimer: momentaryMessageDuration,
		onInput (e) {

			// reset wish list name when it is system-generated
			resetAssetNameIfDefault($(this)[0]);

			// prevent invalid characters
			if (hasInvalidCharsInAssetName(e.which)) {

				return false;

			}

		},
		placeholder: /_/.test($editableElement.text()) ? $editableElement.text() : '', // set placeholder when name is system-generated
		highlightOnFocus: !/_/.test($editableElement.text()), // highlight name on focus when it is not system-generated
		showPlaceholder ($el) {

			// show placeholder text when name is system-generated
			if (/_/.test($el.text())) {

				$el.data('lpContentEditable').resetEditableElement($el);
				return true;

			}
			return false;

		},
		onBeforeSubmit (e, options) {

			window.lp.utils.showStatusIndicator('Updating...');

			// some options need to be set dynamically
			options.ajaxData = {
				Name: $editableElement.text()
			};
			options.submitUrl = `/api/globalwishlists/${lp.wishlist.wishlistToken}/name`;

		},
		ajaxDataFilter (data) {

			let response;
			const that = this;

			try {

				response = JSON.parse(data);

			} catch (e) {

				console.log(e);

			}

			const originalResponse = response;

			if (response) {

				// normalize the ajax response to a new JSON object that the contentEditable plugin expects
				if (response.Success) {

					response = {
						success: true,
						text: response.Name || response.Item,
						error: ''
					};

				} else {

					if (response.ErrorMessage === 'FailureNameAlreadyExists') {

						const editableWishlistHeader = document.getElementById('wishlistHeaderName')
							? document.getElementById('wishlistHeaderName')
							: document.querySelector('.wishlistMobileHeaderName');
						const errorEl = document.querySelector('.validationContainer');

						if (errorEl) {

							errorEl.querySelector('.validationError').innerHTML =								wishListErrorMessages[response.ErrorMessage] || 'Saving failed.';
							errorEl.classList.add('error');
							editableWishlistHeader.classList.add('error');

						} else {

							window.lp.utils.showStatusIndicator(error);

						}
						response = {
							focusEditableElement: true,
							success: false,
							error: wishListErrorMessages[response.ErrorMessage] || 'Saving failed.'
						};

					} else {

						response = {
							success: false,
							error: wishListErrorMessages[response.ErrorMessage] || 'Saving failed.'
						};

					}

				}

			} else {

				response = {
					success: false,
					error: 'Saving failed.'
				};

			}

			response.originalResponse = originalResponse;

			return JSON.stringify(response);

		},
		onAjaxSuccess (response) {

			const instanceOptions = $editableElement.data('lpContentEditable').options;
			instanceOptions.placeholder = ''; // reset placeholder since the editable element name is not system-generated anymore
			instanceOptions.highlightOnFocus = true; // enable highlighting of user-generated name when in edit mode

			if (typeof options.onAjaxSuccessCustom === 'function') {

				options.onAjaxSuccessCustom.call(this, response.text, response);

			}

		},
		onAjaxError (jqXHR, textStatus, errorThrown, responseError) {

			if (typeof options.onAjaxErrorCustom === 'function') {

				options.onAjaxErrorCustom.call(this, responseError || errorThrown); // responseError is the returned error message from a successful (HTTP 200) request

			}

		}
	};

	options = $.extend(true, {}, defaults, options);

	$editableElement.contentEditable(options);

};
